(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/libs/highcharts/assets/javascripts/modules/drilldown.src.js') >= 0) return;  svs.modules.push('/components/libs/highcharts/assets/javascripts/modules/drilldown.src.js');
(function (factory) {
    if (typeof module === 'object' && module.exports) {
        factory['default'] = factory;
        module.exports = factory;
    } else if (typeof define === 'function' && define.amd) {
        define('highcharts/modules/drilldown', ['highcharts'], function (Highcharts) {
            factory(Highcharts);
            factory.Highcharts = Highcharts;
            return factory;
        });
    } else {
        factory(typeof Highcharts !== 'undefined' ? Highcharts : undefined);
    }
}(function (Highcharts) {
    'use strict';
    var _modules = Highcharts ? Highcharts._modules : {};
    function _registerModule(obj, path, args, fn) {
        if (!obj.hasOwnProperty(path)) {
            obj[path] = fn.apply(null, args);

            if (typeof CustomEvent === 'function') {
                Highcharts.win.dispatchEvent(new CustomEvent(
                    'HighchartsModuleLoaded',
                    { detail: { path: path, module: obj[path] } }
                ));
            }
        }
    }
    _registerModule(_modules, 'Extensions/Breadcrumbs/BreadcrumbsDefaults.js', [], function () {
        const lang = {
            mainBreadcrumb: 'Main'
        };
        const options = {
            buttonTheme: {
                fill: 'none',
                height: 18,
                padding: 2,
                'stroke-width': 0,
                zIndex: 7,
                states: {
                    select: {
                        fill: 'none'
                    }
                },
                style: {
                    color: "#334eff" 
                }
            },
            buttonSpacing: 5,
            floating: false,
            format: void 0,
            relativeTo: 'plotBox',
            rtl: false,
            position: {
                align: 'left',
                verticalAlign: 'top',
                x: 0,
                y: void 0
            },
            separator: {
                text: '/',
                style: {
                    color: "#666666" ,
                    fontSize: '0.8em'
                }
            },
            showFullPath: true,
            style: {},
            useHTML: false,
            zIndex: 7
        };
        const BreadcrumbsDefaults = {
            lang,
            options
        };

        return BreadcrumbsDefaults;
    });
    _registerModule(_modules, 'Extensions/Breadcrumbs/Breadcrumbs.js', [_modules['Extensions/Breadcrumbs/BreadcrumbsDefaults.js'], _modules['Core/Templating.js'], _modules['Core/Globals.js'], _modules['Core/Utilities.js']], function (BreadcrumbsDefaults, F, H, U) {
        const { format } = F;
        const { composed } = H;
        const { addEvent, defined, extend, fireEvent, isString, merge, objectEach, pick, pushUnique } = U;
        function onChartAfterShowResetZoom() {
            const chart = this;
            if (chart.breadcrumbs) {
                const bbox = chart.resetZoomButton &&
                    chart.resetZoomButton.getBBox(), breadcrumbsOptions = chart.breadcrumbs.options;
                if (bbox &&
                    breadcrumbsOptions.position.align === 'right' &&
                    breadcrumbsOptions.relativeTo === 'plotBox') {
                    chart.breadcrumbs.alignBreadcrumbsGroup(-bbox.width - breadcrumbsOptions.buttonSpacing);
                }
            }
        }
        function onChartDestroy() {
            if (this.breadcrumbs) {
                this.breadcrumbs.destroy();
                this.breadcrumbs = void 0;
            }
        }
        function onChartGetMargins() {
            const breadcrumbs = this.breadcrumbs;
            if (breadcrumbs &&
                !breadcrumbs.options.floating &&
                breadcrumbs.level) {
                const breadcrumbsOptions = breadcrumbs.options, buttonTheme = breadcrumbsOptions.buttonTheme, breadcrumbsHeight = ((buttonTheme.height || 0) +
                    2 * (buttonTheme.padding || 0) +
                    breadcrumbsOptions.buttonSpacing), verticalAlign = breadcrumbsOptions.position.verticalAlign;
                if (verticalAlign === 'bottom') {
                    this.marginBottom = (this.marginBottom || 0) + breadcrumbsHeight;
                    breadcrumbs.yOffset = breadcrumbsHeight;
                }
                else if (verticalAlign !== 'middle') {
                    this.plotTop += breadcrumbsHeight;
                    breadcrumbs.yOffset = -breadcrumbsHeight;
                }
                else {
                    breadcrumbs.yOffset = void 0;
                }
            }
        }
        function onChartRedraw() {
            this.breadcrumbs && this.breadcrumbs.redraw();
        }
        function onChartSelection(event) {
            if (event.resetSelection === true &&
                this.breadcrumbs) {
                this.breadcrumbs.alignBreadcrumbsGroup();
            }
        }
        class Breadcrumbs {
            static compose(ChartClass, highchartsDefaultOptions) {
                if (pushUnique(composed, 'Breadcrumbs')) {
                    addEvent(ChartClass, 'destroy', onChartDestroy);
                    addEvent(ChartClass, 'afterShowResetZoom', onChartAfterShowResetZoom);
                    addEvent(ChartClass, 'getMargins', onChartGetMargins);
                    addEvent(ChartClass, 'redraw', onChartRedraw);
                    addEvent(ChartClass, 'selection', onChartSelection);
                    extend(highchartsDefaultOptions.lang, BreadcrumbsDefaults.lang);
                }
            }
            constructor(chart, userOptions) {
                this.elementList = {};
                this.isDirty = true;
                this.level = 0;
                this.list = [];
                const chartOptions = merge(chart.options.drilldown &&
                    chart.options.drilldown.drillUpButton, Breadcrumbs.defaultOptions, chart.options.navigation && chart.options.navigation.breadcrumbs, userOptions);
                this.chart = chart;
                this.options = chartOptions || {};
            }
            updateProperties(list) {
                this.setList(list);
                this.setLevel();
                this.isDirty = true;
            }
            setList(list) {
                this.list = list;
            }
            setLevel() {
                this.level = this.list.length && this.list.length - 1;
            }
            getLevel() {
                return this.level;
            }
            getButtonText(breadcrumb) {
                const breadcrumbs = this, chart = breadcrumbs.chart, breadcrumbsOptions = breadcrumbs.options, lang = chart.options.lang, textFormat = pick(breadcrumbsOptions.format, breadcrumbsOptions.showFullPath ?
                    '{level.name}' : '← {level.name}'), defaultText = lang && pick(lang.drillUpText, lang.mainBreadcrumb);
                let returnText = breadcrumbsOptions.formatter &&
                    breadcrumbsOptions.formatter(breadcrumb) ||
                    format(textFormat, { level: breadcrumb.levelOptions }, chart) || '';
                if (((isString(returnText) &&
                    !returnText.length) ||
                    returnText === '← ') &&
                    defined(defaultText)) {
                    returnText = !breadcrumbsOptions.showFullPath ?
                        '← ' + defaultText :
                        defaultText;
                }
                return returnText;
            }
            redraw() {
                if (this.isDirty) {
                    this.render();
                }
                if (this.group) {
                    this.group.align();
                }
                this.isDirty = false;
            }
            render() {
                const breadcrumbs = this, chart = breadcrumbs.chart, breadcrumbsOptions = breadcrumbs.options;
                if (!breadcrumbs.group && breadcrumbsOptions) {
                    breadcrumbs.group = chart.renderer
                        .g('breadcrumbs-group')
                        .addClass('highcharts-no-tooltip highcharts-breadcrumbs')
                        .attr({
                        zIndex: breadcrumbsOptions.zIndex
                    })
                        .add();
                }
                if (breadcrumbsOptions.showFullPath) {
                    this.renderFullPathButtons();
                }
                else {
                    this.renderSingleButton();
                }
                this.alignBreadcrumbsGroup();
            }
            renderFullPathButtons() {
                this.destroySingleButton();
                this.resetElementListState();
                this.updateListElements();
                this.destroyListElements();
            }
            renderSingleButton() {
                const breadcrumbs = this, chart = breadcrumbs.chart, list = breadcrumbs.list, breadcrumbsOptions = breadcrumbs.options, buttonSpacing = breadcrumbsOptions.buttonSpacing;
                this.destroyListElements();
                const posX = breadcrumbs.group ?
                    breadcrumbs.group.getBBox().width :
                    buttonSpacing, posY = buttonSpacing;
                const previousBreadcrumb = list[list.length - 2];
                if (!chart.drillUpButton && (this.level > 0)) {
                    chart.drillUpButton = breadcrumbs.renderButton(previousBreadcrumb, posX, posY);
                }
                else if (chart.drillUpButton) {
                    if (this.level > 0) {
                        this.updateSingleButton();
                    }
                    else {
                        this.destroySingleButton();
                    }
                }
            }
            alignBreadcrumbsGroup(xOffset) {
                const breadcrumbs = this;
                if (breadcrumbs.group) {
                    const breadcrumbsOptions = breadcrumbs.options, buttonTheme = breadcrumbsOptions.buttonTheme, positionOptions = breadcrumbsOptions.position, alignTo = (breadcrumbsOptions.relativeTo === 'chart' ||
                        breadcrumbsOptions.relativeTo === 'spacingBox' ?
                        void 0 :
                        'plotBox'), bBox = breadcrumbs.group.getBBox(), additionalSpace = 2 * (buttonTheme.padding || 0) +
                        breadcrumbsOptions.buttonSpacing;
                    positionOptions.width = bBox.width + additionalSpace;
                    positionOptions.height = bBox.height + additionalSpace;
                    const newPositions = merge(positionOptions);
                    if (xOffset) {
                        newPositions.x += xOffset;
                    }
                    if (breadcrumbs.options.rtl) {
                        newPositions.x += positionOptions.width;
                    }
                    newPositions.y = pick(newPositions.y, this.yOffset, 0);
                    breadcrumbs.group.align(newPositions, true, alignTo);
                }
            }
            renderButton(breadcrumb, posX, posY) {
                const breadcrumbs = this, chart = this.chart, breadcrumbsOptions = breadcrumbs.options, buttonTheme = merge(breadcrumbsOptions.buttonTheme);
                const button = chart.renderer
                    .button(breadcrumbs.getButtonText(breadcrumb), posX, posY, function (e) {
                    const buttonEvents = breadcrumbsOptions.events &&
                        breadcrumbsOptions.events.click;
                    let callDefaultEvent;
                    if (buttonEvents) {
                        callDefaultEvent = buttonEvents.call(breadcrumbs, e, breadcrumb);
                    }
                    if (callDefaultEvent !== false) {
                        if (!breadcrumbsOptions.showFullPath) {
                            e.newLevel = breadcrumbs.level - 1;
                        }
                        else {
                            e.newLevel = breadcrumb.level;
                        }
                        fireEvent(breadcrumbs, 'up', e);
                    }
                }, buttonTheme)
                    .addClass('highcharts-breadcrumbs-button')
                    .add(breadcrumbs.group);
                if (!chart.styledMode) {
                    button.attr(breadcrumbsOptions.style);
                }
                return button;
            }
            renderSeparator(posX, posY) {
                const breadcrumbs = this, chart = this.chart, breadcrumbsOptions = breadcrumbs.options, separatorOptions = breadcrumbsOptions.separator;
                const separator = chart.renderer
                    .label(separatorOptions.text, posX, posY, void 0, void 0, void 0, false)
                    .addClass('highcharts-breadcrumbs-separator')
                    .add(breadcrumbs.group);
                if (!chart.styledMode) {
                    separator.css(separatorOptions.style);
                }
                return separator;
            }
            update(options) {
                merge(true, this.options, options);
                this.destroy();
                this.isDirty = true;
            }
            updateSingleButton() {
                const chart = this.chart, currentBreadcrumb = this.list[this.level - 1];
                if (chart.drillUpButton) {
                    chart.drillUpButton.attr({
                        text: this.getButtonText(currentBreadcrumb)
                    });
                }
            }
            destroy() {
                this.destroySingleButton();
                this.destroyListElements(true);
                if (this.group) {
                    this.group.destroy();
                }
                this.group = void 0;
            }
            destroyListElements(force) {
                const elementList = this.elementList;
                objectEach(elementList, (element, level) => {
                    if (force ||
                        !elementList[level].updated) {
                        element = elementList[level];
                        element.button && element.button.destroy();
                        element.separator && element.separator.destroy();
                        delete element.button;
                        delete element.separator;
                        delete elementList[level];
                    }
                });
                if (force) {
                    this.elementList = {};
                }
            }
            destroySingleButton() {
                if (this.chart.drillUpButton) {
                    this.chart.drillUpButton.destroy();
                    this.chart.drillUpButton = void 0;
                }
            }
            resetElementListState() {
                objectEach(this.elementList, (element) => {
                    element.updated = false;
                });
            }
            updateListElements() {
                const breadcrumbs = this, elementList = breadcrumbs.elementList, buttonSpacing = breadcrumbs.options.buttonSpacing, posY = buttonSpacing, list = breadcrumbs.list, rtl = breadcrumbs.options.rtl, rtlFactor = rtl ? -1 : 1, updateXPosition = function (element, spacing) {
                    return rtlFactor * element.getBBox().width +
                        rtlFactor * spacing;
                }, adjustToRTL = function (element, posX, posY) {
                    element.translate(posX - element.getBBox().width, posY);
                };
                let posX = breadcrumbs.group ?
                    updateXPosition(breadcrumbs.group, buttonSpacing) :
                    buttonSpacing, currentBreadcrumb, breadcrumb;
                for (let i = 0, iEnd = list.length; i < iEnd; ++i) {
                    const isLast = i === iEnd - 1;
                    let button, separator;
                    breadcrumb = list[i];
                    if (elementList[breadcrumb.level]) {
                        currentBreadcrumb = elementList[breadcrumb.level];
                        button = currentBreadcrumb.button;
                        if (!currentBreadcrumb.separator &&
                            !isLast) {
                            posX += rtlFactor * buttonSpacing;
                            currentBreadcrumb.separator =
                                breadcrumbs.renderSeparator(posX, posY);
                            if (rtl) {
                                adjustToRTL(currentBreadcrumb.separator, posX, posY);
                            }
                            posX += updateXPosition(currentBreadcrumb.separator, buttonSpacing);
                        }
                        else if (currentBreadcrumb.separator &&
                            isLast) {
                            currentBreadcrumb.separator.destroy();
                            delete currentBreadcrumb.separator;
                        }
                        elementList[breadcrumb.level].updated = true;
                    }
                    else {
                        button = breadcrumbs.renderButton(breadcrumb, posX, posY);
                        if (rtl) {
                            adjustToRTL(button, posX, posY);
                        }
                        posX += updateXPosition(button, buttonSpacing);
                        if (!isLast) {
                            separator = breadcrumbs.renderSeparator(posX, posY);
                            if (rtl) {
                                adjustToRTL(separator, posX, posY);
                            }
                            posX += updateXPosition(separator, buttonSpacing);
                        }
                        elementList[breadcrumb.level] = {
                            button,
                            separator,
                            updated: true
                        };
                    }
                    if (button) {
                        button.setState(isLast ? 2 : 0);
                    }
                }
            }
        }
        Breadcrumbs.defaultOptions = BreadcrumbsDefaults.options;
        (''); 

        return Breadcrumbs;
    });
    _registerModule(_modules, 'Extensions/Drilldown/DrilldownDefaults.js', [], function () {
        const DrilldownDefaults = {
            activeAxisLabelStyle: {
                cursor: 'pointer',
                color: "#0022ff" ,
                fontWeight: 'bold',
                textDecoration: 'underline'
            },
            activeDataLabelStyle: {
                cursor: 'pointer',
                color: "#0022ff" ,
                fontWeight: 'bold',
                textDecoration: 'underline'
            },
            animation: {
                duration: 500
            },
            drillUpButton: {
                position: {
                    align: 'right',
                    x: -10,
                    y: 10
                }
            },
            mapZooming: true
        };
        ''; 

        return DrilldownDefaults;
    });
    _registerModule(_modules, 'Extensions/Drilldown/DrilldownSeries.js', [_modules['Core/Animation/AnimationUtilities.js'], _modules['Core/Utilities.js']], function (A, U) {
        const { animObject } = A;
        const { addEvent, extend, fireEvent, merge, pick, syncTimeout } = U;
        function applyCursorCSS(element, cursor, addClass, styledMode) {
            element[addClass ? 'addClass' : 'removeClass']('highcharts-drilldown-point');
            if (!styledMode) {
                element.css({ cursor: cursor });
            }
        }
        function columnAnimateDrilldown(init) {
            const series = this, chart = series.chart, drilldownLevels = chart.drilldownLevels, animationOptions = animObject((chart.options.drilldown || {}).animation), xAxis = this.xAxis, styledMode = chart.styledMode;
            if (!init) {
                let animateFrom;
                (drilldownLevels || []).forEach((level) => {
                    if (series.options._ddSeriesId ===
                        level.lowerSeriesOptions._ddSeriesId) {
                        animateFrom = level.shapeArgs;
                        if (!styledMode && animateFrom) {
                            animateFrom.fill = level.color;
                        }
                    }
                });
                animateFrom.x += pick(xAxis.oldPos, xAxis.pos) - xAxis.pos;
                series.points.forEach((point) => {
                    const animateTo = point.shapeArgs;
                    if (!styledMode) {
                        animateTo.fill = point.color;
                    }
                    if (point.graphic) {
                        point.graphic
                            .attr(animateFrom)
                            .animate(extend(point.shapeArgs, { fill: point.color || series.color }), animationOptions);
                    }
                });
                if (chart.drilldown) {
                    chart.drilldown.fadeInGroup(this.dataLabelsGroup);
                }
                delete this.animate;
            }
        }
        function columnAnimateDrillupFrom(level) {
            const series = this, animationOptions = animObject((series.chart.options.drilldown || {}).animation);
            (series.trackerGroups || []).forEach((key) => {
                if (series[key]) {
                    series[key].on('mouseover');
                }
            });
            let group = series.group;
            const removeGroup = group !== series.chart.columnGroup;
            if (removeGroup) {
                delete series.group;
            }
            this.points.forEach((point) => {
                const graphic = point.graphic, animateTo = level.shapeArgs;
                if (graphic && animateTo) {
                    const complete = () => {
                        graphic.destroy();
                        if (group && removeGroup) {
                            group = group.destroy();
                        }
                    };
                    delete point.graphic;
                    if (!series.chart.styledMode) {
                        animateTo.fill = level.color;
                    }
                    if (animationOptions.duration) {
                        graphic.animate(animateTo, merge(animationOptions, { complete: complete }));
                    }
                    else {
                        graphic.attr(animateTo);
                        complete();
                    }
                }
            });
        }
        function columnAnimateDrillupTo(init) {
            const series = this, level = series.drilldownLevel;
            if (!init) {
                series.points.forEach((point) => {
                    const dataLabel = point.dataLabel;
                    if (point.graphic) { 
                        point.graphic.hide();
                    }
                    if (dataLabel) {
                        dataLabel.hidden = dataLabel.attr('visibility') === 'hidden';
                        if (!dataLabel.hidden) {
                            dataLabel.hide();
                            dataLabel.connector?.hide();
                        }
                    }
                });
                syncTimeout(() => {
                    if (series.points) { 
                        let pointsWithNodes = [];
                        series.data.forEach((el) => {
                            pointsWithNodes.push(el);
                        });
                        if (series.nodes) {
                            pointsWithNodes = pointsWithNodes.concat(series.nodes);
                        }
                        pointsWithNodes.forEach((point, i) => {
                            const verb = i === (level && level.pointIndex) ? 'show' : 'fadeIn', inherit = verb === 'show' ? true : void 0, dataLabel = point.dataLabel;
                            if (point.graphic && 
                                point.visible 
                            ) {
                                point.graphic[verb](inherit);
                            }
                            if (dataLabel && !dataLabel.hidden) { 
                                dataLabel.fadeIn(); 
                                dataLabel.connector?.fadeIn();
                            }
                        });
                    }
                }, Math.max(series.chart.options.drilldown.animation.duration - 50, 0));
                delete this.animate;
            }
        }
        function compose(SeriesClass, seriesTypes) {
            const PointClass = SeriesClass.prototype.pointClass, pointProto = PointClass.prototype;
            if (!pointProto.doDrilldown) {
                const { column: ColumnSeriesClass, map: MapSeriesClass, pie: PieSeriesClass } = seriesTypes;
                addEvent(PointClass, 'afterInit', onPointAfterInit);
                addEvent(PointClass, 'afterSetState', onPointAfterSetState);
                addEvent(PointClass, 'update', onPointUpdate);
                pointProto.doDrilldown = pointDoDrilldown;
                pointProto.runDrilldown = pointRunDrilldown;
                addEvent(SeriesClass, 'afterDrawDataLabels', onSeriesAfterDrawDataLabels);
                addEvent(SeriesClass, 'afterDrawTracker', onSeriesAfterDrawTracker);
                if (ColumnSeriesClass) {
                    const columnProto = ColumnSeriesClass.prototype;
                    columnProto.animateDrilldown = columnAnimateDrilldown;
                    columnProto.animateDrillupFrom = columnAnimateDrillupFrom;
                    columnProto.animateDrillupTo = columnAnimateDrillupTo;
                }
                if (MapSeriesClass) {
                    const mapProto = MapSeriesClass.prototype;
                    mapProto.animateDrilldown = mapAnimateDrilldown;
                    mapProto.animateDrillupFrom = mapAnimateDrillupFrom;
                    mapProto.animateDrillupTo = mapAnimateDrillupTo;
                }
                if (PieSeriesClass) {
                    const pieProto = PieSeriesClass.prototype;
                    pieProto.animateDrilldown = pieAnimateDrilldown;
                    pieProto.animateDrillupFrom = columnAnimateDrillupFrom;
                    pieProto.animateDrillupTo = columnAnimateDrillupTo;
                }
            }
        }
        function mapAnimateDrilldown(init) {
            const series = this, chart = series.chart, group = series.group;
            if (chart &&
                group &&
                series.options &&
                chart.options.drilldown &&
                chart.options.drilldown.animation) {
                if (init && chart.mapView) {
                    group.attr({
                        opacity: 0.01
                    });
                    chart.mapView.allowTransformAnimation = false;
                    series.options.inactiveOtherPoints = true;
                    series.options.enableMouseTracking = false;
                }
                else {
                    group.animate({
                        opacity: 1
                    }, chart.options.drilldown.animation, () => {
                        if (series.options) {
                            series.options.inactiveOtherPoints = false;
                            series.options.enableMouseTracking =
                                pick((series.userOptions &&
                                    series.userOptions.enableMouseTracking), true);
                            series.isDirty = true;
                            chart.redraw();
                        }
                    });
                    if (chart.drilldown) {
                        chart.drilldown.fadeInGroup(this.dataLabelsGroup);
                    }
                }
            }
        }
        function mapAnimateDrillupFrom() {
            const series = this, chart = series.chart;
            if (chart && chart.mapView) {
                chart.mapView.allowTransformAnimation = false;
            }
            if (series.options) {
                series.options.inactiveOtherPoints = true;
            }
        }
        function mapAnimateDrillupTo(init) {
            const series = this, chart = series.chart, group = series.group;
            if (chart && group) {
                if (init) {
                    group.attr({
                        opacity: 0.01
                    });
                    if (series.options) {
                        series.options.inactiveOtherPoints = true;
                    }
                }
                else {
                    group.animate({ opacity: 1 }, (chart.options.drilldown || {}).animation);
                    if (chart.drilldown) {
                        chart.drilldown.fadeInGroup(series.dataLabelsGroup);
                    }
                }
            }
        }
        function onPointAfterInit() {
            const point = this;
            if (point.drilldown && !point.unbindDrilldownClick) {
                point.unbindDrilldownClick = addEvent(point, 'click', onPointClick);
            }
            return point;
        }
        function onPointAfterSetState() {
            const point = this, series = point.series, styledMode = series.chart.styledMode;
            if (point.drilldown && series.halo && point.state === 'hover') {
                applyCursorCSS(series.halo, 'pointer', true, styledMode);
            }
            else if (series.halo) {
                applyCursorCSS(series.halo, 'auto', false, styledMode);
            }
        }
        function onPointClick(e) {
            const point = this, series = point.series;
            if (series.xAxis &&
                (series.chart.options.drilldown || {}).allowPointDrilldown ===
                    false) {
                series.xAxis.drilldownCategory(point.x, e);
            }
            else {
                point.runDrilldown(void 0, void 0, e);
            }
        }
        function onPointUpdate(e) {
            const point = this, options = e.options || {};
            if (options.drilldown && !point.unbindDrilldownClick) {
                point.unbindDrilldownClick = addEvent(point, 'click', onPointClick);
            }
            else if (!options.drilldown &&
                options.drilldown !== void 0 &&
                point.unbindDrilldownClick) {
                point.unbindDrilldownClick = point.unbindDrilldownClick();
            }
        }
        function onSeriesAfterDrawDataLabels() {
            const series = this, chart = series.chart, css = chart.options.drilldown.activeDataLabelStyle, renderer = chart.renderer, styledMode = chart.styledMode;
            for (const point of series.points) {
                const dataLabelsOptions = point.options.dataLabels, pointCSS = pick(point.dlOptions, dataLabelsOptions && dataLabelsOptions.style, {});
                if (point.drilldown && point.dataLabel) {
                    if (css.color === 'contrast' && !styledMode) {
                        pointCSS.color = renderer.getContrast(point.color || series.color);
                    }
                    if (dataLabelsOptions && dataLabelsOptions.color) {
                        pointCSS.color = dataLabelsOptions.color;
                    }
                    point.dataLabel
                        .addClass('highcharts-drilldown-data-label');
                    if (!styledMode) {
                        point.dataLabel
                            .css(css)
                            .css(pointCSS);
                    }
                }
            }
        }
        function onSeriesAfterDrawTracker() {
            const series = this, styledMode = series.chart.styledMode;
            for (const point of series.points) {
                if (point.drilldown && point.graphic) {
                    applyCursorCSS(point.graphic, 'pointer', true, styledMode);
                }
            }
        }
        function pieAnimateDrilldown(init) {
            const series = this, chart = series.chart, points = series.points, level = chart.drilldownLevels[chart.drilldownLevels.length - 1], animationOptions = chart.options.drilldown.animation;
            if (series.is('item')) {
                animationOptions.duration = 0;
            }
            if (series.center) {
                const animateFrom = level.shapeArgs, start = animateFrom.start, angle = animateFrom.end - start, startAngle = angle / series.points.length, styledMode = chart.styledMode;
                if (!init) {
                    let animateTo, point;
                    for (let i = 0, iEnd = points.length; i < iEnd; ++i) {
                        point = points[i];
                        animateTo = point.shapeArgs;
                        if (!styledMode) {
                            animateFrom.fill = level.color;
                            animateTo.fill = point.color;
                        }
                        if (point.graphic) {
                            point.graphic.attr(merge(animateFrom, {
                                start: start + i * startAngle,
                                end: start + (i + 1) * startAngle
                            }))[animationOptions ? 'animate' : 'attr'](animateTo, animationOptions);
                        }
                    }
                    if (chart.drilldown) {
                        chart.drilldown.fadeInGroup(series.dataLabelsGroup);
                    }
                    delete series.animate;
                }
            }
        }
        function pointDoDrilldown() {
            this.runDrilldown();
        }
        function pointRunDrilldown(holdRedraw, category, originalEvent) {
            const point = this, series = point.series, chart = series.chart, drilldown = chart.options.drilldown || {};
            let i = (drilldown.series || []).length, seriesOptions;
            if (!chart.ddDupes) {
                chart.ddDupes = [];
            }
            chart.colorCounter = chart.symbolCounter = 0;
            while (i-- && !seriesOptions) {
                if (drilldown.series &&
                    drilldown.series[i].id === point.drilldown &&
                    point.drilldown &&
                    chart.ddDupes.indexOf(point.drilldown) === -1) {
                    seriesOptions = drilldown.series[i];
                    chart.ddDupes.push(point.drilldown);
                }
            }
            fireEvent(chart, 'drilldown', {
                point,
                seriesOptions: seriesOptions,
                category: category,
                originalEvent: originalEvent,
                points: (typeof category !== 'undefined' &&
                    series.xAxis.getDDPoints(category).slice(0))
            }, (e) => {
                const chart = e.point.series && e.point.series.chart, seriesOptions = e.seriesOptions;
                if (chart && seriesOptions) {
                    if (holdRedraw) {
                        chart.addSingleSeriesAsDrilldown(e.point, seriesOptions);
                    }
                    else {
                        chart.addSeriesAsDrilldown(e.point, seriesOptions);
                    }
                }
            });
        }
        const DrilldownSeries = {
            compose
        };

        return DrilldownSeries;
    });
    _registerModule(_modules, 'Extensions/Drilldown/Drilldown.js', [_modules['Core/Animation/AnimationUtilities.js'], _modules['Extensions/Breadcrumbs/Breadcrumbs.js'], _modules['Core/Color/Color.js'], _modules['Core/Globals.js'], _modules['Extensions/Drilldown/DrilldownDefaults.js'], _modules['Extensions/Drilldown/DrilldownSeries.js'], _modules['Core/Utilities.js']], function (A, Breadcrumbs, Color, H, DrilldownDefaults, DrilldownSeries, U) {
        const { animObject } = A;
        const { noop } = H;
        const { addEvent, defined, diffObjects, extend, fireEvent, merge, objectEach, pick, removeEvent, syncTimeout } = U;
        let ddSeriesId = 1;
        function axisDrilldownCategory(x, originalEvent) {
            this.getDDPoints(x).forEach(function (point) {
                if (point &&
                    point.series &&
                    point.series.visible &&
                    point.runDrilldown) { 
                    point.runDrilldown(true, x, originalEvent);
                }
            });
            this.chart.applyDrilldown();
        }
        function axisGetDDPoints(x) {
            return (this.ddPoints && this.ddPoints[x] || []);
        }
        function createBreadcrumbsList(chart) {
            const list = [], drilldownLevels = chart.drilldownLevels;
            if (drilldownLevels && drilldownLevels.length) {
                if (!list[0]) {
                    list.push({
                        level: 0,
                        levelOptions: drilldownLevels[0].seriesOptions
                    });
                }
                drilldownLevels.forEach(function (level) {
                    const lastBreadcrumb = list[list.length - 1];
                    if (level.levelNumber + 1 > lastBreadcrumb.level) {
                        list.push({
                            level: level.levelNumber + 1,
                            levelOptions: merge({
                                name: level.lowerSeries.name
                            }, level.pointOptions)
                        });
                    }
                });
            }
            return list;
        }
        class ChartAdditions {
            constructor(chart) {
                this.chart = chart;
            }
            addSeriesAsDrilldown(point, options) {
                const chart = (this.chart ||
                    this);
                fireEvent(this, 'addSeriesAsDrilldown', { seriesOptions: options });
                if (chart.mapView) {
                    point.series.isDrilling = true;
                    chart.series.forEach((series) => {
                        series.options.inactiveOtherPoints = true;
                        series.dataLabelsGroup?.destroy();
                        delete series.dataLabelsGroup;
                    });
                    if (chart.options.drilldown &&
                        !chart.mapView.projection.hasGeoProjection &&
                        DrilldownDefaults) {
                        const userDrilldown = diffObjects(chart.options.drilldown, DrilldownDefaults);
                        if (!defined(userDrilldown.mapZooming)) {
                            chart.options.drilldown.mapZooming = false;
                        }
                    }
                    if (chart.options.drilldown &&
                        chart.options.drilldown.animation &&
                        chart.options.drilldown.mapZooming) {
                        chart.mapView.allowTransformAnimation = true;
                        const animOptions = animObject(chart.options.drilldown.animation);
                        if (typeof animOptions !== 'boolean') {
                            const userComplete = animOptions.complete, drilldownComplete = function (obj) {
                                if (obj && obj.applyDrilldown && chart.mapView) {
                                    chart
                                        .addSingleSeriesAsDrilldown(point, options);
                                    chart.applyDrilldown();
                                    chart.mapView.allowTransformAnimation = false;
                                }
                            };
                            animOptions.complete =
                                function () {
                                    if (userComplete) {
                                        userComplete.apply(this, arguments);
                                    }
                                    drilldownComplete.apply(this, arguments);
                                };
                        }
                        point.zoomTo(animOptions);
                    }
                    else {
                        chart.addSingleSeriesAsDrilldown(point, options);
                        chart.applyDrilldown();
                    }
                }
                else {
                    chart.addSingleSeriesAsDrilldown(point, options);
                    chart.applyDrilldown();
                }
            }
            addSingleSeriesAsDrilldown(point, ddOptions) {
                const chart = (this.chart ||
                    this), oldSeries = point.series, xAxis = oldSeries.xAxis, yAxis = oldSeries.yAxis, colorProp = chart.styledMode ?
                    { colorIndex: pick(point.colorIndex, oldSeries.colorIndex) } :
                    { color: point.color || oldSeries.color }, levelNumber = oldSeries.options._levelNumber || 0, pointIndex = oldSeries.points.indexOf(point);
                if (!chart.drilldownLevels) {
                    chart.drilldownLevels = [];
                }
                ddOptions = extend(extend({
                    _ddSeriesId: ddSeriesId++
                }, colorProp), ddOptions);
                let levelSeries = [], levelSeriesOptions = [], last;
                last = chart.drilldownLevels[chart.drilldownLevels.length - 1];
                if (last && last.levelNumber !== levelNumber) {
                    last = void 0;
                }
                oldSeries.chart.series.forEach((series) => {
                    if (series.xAxis === xAxis) {
                        series.options._ddSeriesId =
                            series.options._ddSeriesId || ddSeriesId++;
                        series.options.colorIndex = series.colorIndex;
                        series.options._levelNumber =
                            series.options._levelNumber || levelNumber; 
                        if (last) {
                            levelSeries = last.levelSeries;
                            levelSeriesOptions = last.levelSeriesOptions;
                        }
                        else {
                            levelSeries.push(series);
                            series.purgedOptions = merge({
                                _ddSeriesId: series.options._ddSeriesId,
                                _levelNumber: series.options._levelNumber,
                                selected: series.options.selected
                            }, series.userOptions);
                            levelSeriesOptions.push(series.purgedOptions);
                        }
                    }
                });
                const level = extend({
                    levelNumber: levelNumber,
                    seriesOptions: oldSeries.options,
                    seriesPurgedOptions: oldSeries.purgedOptions,
                    levelSeriesOptions: levelSeriesOptions,
                    levelSeries: levelSeries,
                    shapeArgs: point.shapeArgs,
                    bBox: point.graphic ? point.graphic.getBBox() : {},
                    color: point.isNull ?
                        Color.parse(colorProp.color).setOpacity(0).get() :
                        colorProp.color,
                    lowerSeriesOptions: ddOptions,
                    pointOptions: oldSeries.options.data[pointIndex],
                    pointIndex: pointIndex,
                    oldExtremes: {
                        xMin: xAxis && xAxis.userMin,
                        xMax: xAxis && xAxis.userMax,
                        yMin: yAxis && yAxis.userMin,
                        yMax: yAxis && yAxis.userMax
                    },
                    resetZoomButton: last && last.levelNumber === levelNumber ?
                        void 0 : chart.resetZoomButton
                }, colorProp);
                chart.drilldownLevels.push(level);
                if (xAxis && xAxis.names) {
                    xAxis.names.length = 0;
                }
                const newSeries = level.lowerSeries = chart.addSeries(ddOptions, false);
                newSeries.options._levelNumber = levelNumber + 1;
                if (xAxis) {
                    xAxis.oldPos = xAxis.pos;
                    xAxis.userMin = xAxis.userMax = null;
                    yAxis.userMin = yAxis.userMax = null;
                }
                newSeries.isDrilling = true;
                if (oldSeries.type === newSeries.type) {
                    newSeries.animate = (newSeries.animateDrilldown || noop);
                    newSeries.options.animation = true;
                }
            }
            applyDrilldown() {
                const chart = (this.chart ||
                    this), drilldownLevels = chart.drilldownLevels;
                let levelToRemove;
                if (drilldownLevels && drilldownLevels.length > 0) {
                    levelToRemove =
                        drilldownLevels[drilldownLevels.length - 1].levelNumber;
                    chart.hasCartesianSeries = drilldownLevels.some((level) => level.lowerSeries.isCartesian 
                    );
                    (chart.drilldownLevels || []).forEach((level) => {
                        if (chart.mapView &&
                            chart.options.drilldown &&
                            chart.options.drilldown.mapZooming) {
                            chart.redraw();
                            level.lowerSeries.isDrilling = false;
                            chart.mapView.fitToBounds(level.lowerSeries.bounds);
                            level.lowerSeries.isDrilling = true;
                        }
                        if (level.levelNumber === levelToRemove) {
                            level.levelSeries.forEach((series) => {
                                if (!chart.mapView) {
                                    if (series.options &&
                                        series.options._levelNumber === levelToRemove) {
                                        series.remove(false);
                                    }
                                }
                                else if (series.options &&
                                    series.options._levelNumber === levelToRemove &&
                                    series.group) {
                                    let animOptions = {};
                                    if (chart.options.drilldown) {
                                        animOptions = chart.options.drilldown.animation;
                                    }
                                    series.group.animate({
                                        opacity: 0
                                    }, animOptions, () => {
                                        series.remove(false);
                                        if (!(level.levelSeries.filter((el) => Object.keys(el).length)).length) {
                                            if (chart.resetZoomButton) {
                                                chart.resetZoomButton.hide();
                                                delete chart.resetZoomButton;
                                            }
                                            chart.pointer?.reset();
                                            fireEvent(chart, 'afterDrilldown');
                                            if (chart.mapView) {
                                                chart.series.forEach((series) => {
                                                    series.isDirtyData = true;
                                                    series.isDrilling = false;
                                                });
                                                chart.mapView
                                                    .fitToBounds(void 0, void 0);
                                                chart.mapView.allowTransformAnimation =
                                                    true; 
                                            }
                                            fireEvent(chart, 'afterApplyDrilldown');
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
                if (!chart.mapView) {
                    if (chart.resetZoomButton) {
                        chart.resetZoomButton.hide();
                        delete chart.resetZoomButton;
                    }
                    chart.pointer?.reset();
                    fireEvent(chart, 'afterDrilldown');
                    if (!chart.hasCartesianSeries) {
                        chart.axes.forEach((axis) => {
                            axis.destroy(true);
                            axis.init(chart, merge(axis.userOptions, axis.options));
                        });
                    }
                    chart.redraw();
                    fireEvent(chart, 'afterApplyDrilldown');
                }
            }
            drillUp(isMultipleDrillUp) {
                const chart = (this.chart ||
                    this);
                if (!chart.drilldownLevels || chart.drilldownLevels.length === 0) {
                    return;
                }
                fireEvent(chart, 'beforeDrillUp');
                const drilldownLevels = chart.drilldownLevels, levelNumber = drilldownLevels[drilldownLevels.length - 1].levelNumber, chartSeries = chart.series, drilldownLevelsNumber = chart.drilldownLevels.length, addSeries = (seriesOptions, oldSeries) => {
                    let addedSeries;
                    chartSeries.forEach((series) => {
                        if (series.options._ddSeriesId ===
                            seriesOptions._ddSeriesId) {
                            addedSeries = series;
                        }
                    });
                    addedSeries =
                        addedSeries || chart.addSeries(seriesOptions, false);
                    if (addedSeries.type === oldSeries.type &&
                        addedSeries.animateDrillupTo) {
                        addedSeries.animate = addedSeries.animateDrillupTo;
                    }
                    if (seriesOptions === level.seriesPurgedOptions) {
                        return addedSeries;
                    }
                }, removeSeries = (oldSeries) => {
                    oldSeries.remove(false);
                    chart.series.forEach((series) => {
                        if (series.colorAxis) {
                            series.isDirtyData = true;
                        }
                        series.options.inactiveOtherPoints = false;
                    });
                    chart.redraw();
                };
                let i = drilldownLevels.length, seriesI, level, oldExtremes;
                chart.symbolCounter = chart.colorCounter = 0;
                while (i--) {
                    let oldSeries, newSeries;
                    level = drilldownLevels[i];
                    if (level.levelNumber === levelNumber) {
                        drilldownLevels.pop();
                        oldSeries = level.lowerSeries;
                        if (!oldSeries.chart) { 
                            seriesI = chartSeries.length; 
                            while (seriesI--) {
                                if (chartSeries[seriesI].options.id ===
                                    level.lowerSeriesOptions.id &&
                                    chartSeries[seriesI].options._levelNumber ===
                                        levelNumber + 1) { 
                                    oldSeries = chartSeries[seriesI];
                                    break;
                                }
                            }
                        }
                        oldSeries.xData = []; 
                        if (oldSeries.xAxis &&
                            oldSeries.xAxis.names &&
                            (drilldownLevelsNumber === 0 ||
                                i === drilldownLevelsNumber - 1)) {
                            oldSeries.xAxis.names.length = 0;
                        }
                        level.levelSeriesOptions.forEach((el) => {
                            const addedSeries = addSeries(el, oldSeries);
                            if (addedSeries) {
                                newSeries = addedSeries;
                            }
                        });
                        fireEvent(chart, 'drillup', {
                            seriesOptions: level.seriesPurgedOptions ||
                                level.seriesOptions
                        });
                        if (newSeries) {
                            if (newSeries.type === oldSeries.type) {
                                newSeries.drilldownLevel = level;
                                newSeries.options.animation =
                                    chart.options.drilldown.animation;
                                if (oldSeries.animateDrillupFrom && oldSeries.chart) {
                                    oldSeries.animateDrillupFrom(level);
                                }
                            }
                            newSeries.options._levelNumber = levelNumber;
                        }
                        const seriesToRemove = oldSeries;
                        if (!chart.mapView) {
                            seriesToRemove.remove(false);
                        }
                        if (newSeries && newSeries.xAxis) {
                            oldExtremes = level.oldExtremes;
                            newSeries.xAxis.setExtremes(oldExtremes.xMin, oldExtremes.xMax, false);
                            newSeries.yAxis.setExtremes(oldExtremes.yMin, oldExtremes.yMax, false);
                        }
                        if (level.resetZoomButton) {
                            chart.resetZoomButton = level.resetZoomButton;
                        }
                        if (!chart.mapView) {
                            fireEvent(chart, 'afterDrillUp');
                        }
                        else {
                            const shouldAnimate = level.levelNumber === levelNumber &&
                                isMultipleDrillUp, zoomingDrill = chart.options.drilldown &&
                                chart.options.drilldown.animation &&
                                chart.options.drilldown.mapZooming;
                            if (shouldAnimate) {
                                oldSeries.remove(false);
                            }
                            else {
                                if (oldSeries.dataLabelsGroup) {
                                    oldSeries.dataLabelsGroup.destroy();
                                    delete oldSeries.dataLabelsGroup;
                                }
                                if (chart.mapView && newSeries) {
                                    if (zoomingDrill) {
                                        oldSeries.isDrilling = true;
                                        newSeries.isDrilling = true;
                                        chart.redraw(false);
                                        chart.mapView.fitToBounds(oldSeries.bounds, void 0, true, false);
                                    }
                                    chart.mapView.allowTransformAnimation = true;
                                    fireEvent(chart, 'afterDrillUp', {
                                        seriesOptions: newSeries ? newSeries.userOptions : void 0
                                    });
                                    if (zoomingDrill) {
                                        chart.mapView.setView(void 0, pick(chart.mapView.minZoom, 1), true, {
                                            complete: function () {
                                                if (Object.prototype.hasOwnProperty
                                                    .call(this, 'complete')) {
                                                    removeSeries(oldSeries);
                                                }
                                            }
                                        });
                                        newSeries._hasTracking = false;
                                    }
                                    else {
                                        chart.mapView.allowTransformAnimation = false;
                                        if (oldSeries.group) {
                                            oldSeries.group.animate({
                                                opacity: 0
                                            }, chart.options.drilldown.animation, () => {
                                                removeSeries(oldSeries);
                                                if (chart.mapView) {
                                                    chart.mapView
                                                        .allowTransformAnimation = true;
                                                }
                                            });
                                        }
                                        else {
                                            removeSeries(oldSeries);
                                            chart.mapView
                                                .allowTransformAnimation = true;
                                        }
                                    }
                                    newSeries.isDrilling = false;
                                }
                            }
                        }
                    }
                }
                if (!chart.mapView) {
                    chart.redraw();
                }
                if (chart.ddDupes) {
                    chart.ddDupes.length = 0; 
                } 
                fireEvent(chart, 'drillupall');
            }
            fadeInGroup(group) {
                const chart = this.chart, animationOptions = animObject(chart.options.drilldown.animation);
                if (group) {
                    group.hide();
                    syncTimeout(() => {
                        if (group && group.added) {
                            group.fadeIn();
                        }
                    }, Math.max(animationOptions.duration - 50, 0));
                }
            }
            update(options, redraw) {
                const chart = this.chart;
                merge(true, chart.options.drilldown, options);
                if (pick(redraw, true)) {
                    chart.redraw();
                }
            }
        }
        var Drilldown;
        (function (Drilldown) {
            function compose(AxisClass, ChartClass, highchartsDefaultOptions, SeriesClass, seriesTypes, SVGRendererClass, TickClass) {
                DrilldownSeries.compose(SeriesClass, seriesTypes);
                const DrilldownChart = ChartClass, chartProto = DrilldownChart.prototype;
                if (!chartProto.drillUp) {
                    const SVGElementClass = SVGRendererClass.prototype.Element, addonProto = ChartAdditions.prototype, axisProto = AxisClass.prototype, elementProto = SVGElementClass.prototype, tickProto = TickClass.prototype;
                    axisProto.drilldownCategory = axisDrilldownCategory;
                    axisProto.getDDPoints = axisGetDDPoints;
                    Breadcrumbs.compose(ChartClass, highchartsDefaultOptions);
                    addEvent(Breadcrumbs, 'up', onBreadcrumbsUp);
                    chartProto.addSeriesAsDrilldown = addonProto.addSeriesAsDrilldown;
                    chartProto.addSingleSeriesAsDrilldown =
                        addonProto.addSingleSeriesAsDrilldown;
                    chartProto.applyDrilldown = addonProto.applyDrilldown;
                    chartProto.drillUp = addonProto.drillUp;
                    addEvent(DrilldownChart, 'afterDrilldown', onChartAfterDrilldown);
                    addEvent(DrilldownChart, 'afterDrillUp', onChartAfterDrillUp);
                    addEvent(DrilldownChart, 'afterInit', onChartAfterInit);
                    addEvent(DrilldownChart, 'drillup', onChartDrillup);
                    addEvent(DrilldownChart, 'drillupall', onChartDrillupall);
                    addEvent(DrilldownChart, 'render', onChartRender);
                    addEvent(DrilldownChart, 'update', onChartUpdate);
                    highchartsDefaultOptions.drilldown = DrilldownDefaults;
                    elementProto.fadeIn = svgElementFadeIn;
                    tickProto.drillable = tickDrillable;
                }
            }
            Drilldown.compose = compose;
            function onBreadcrumbsUp(e) {
                const chart = this.chart, drillUpsNumber = this.getLevel() - e.newLevel;
                let isMultipleDrillUp = drillUpsNumber > 1;
                for (let i = 0; i < drillUpsNumber; i++) {
                    if (i === drillUpsNumber - 1) {
                        isMultipleDrillUp = false;
                    }
                    chart.drillUp(isMultipleDrillUp);
                }
            }
            function onChartAfterDrilldown() {
                const chart = this, drilldownOptions = chart.options.drilldown, breadcrumbsOptions = drilldownOptions && drilldownOptions.breadcrumbs;
                if (!chart.breadcrumbs) {
                    chart.breadcrumbs = new Breadcrumbs(chart, breadcrumbsOptions);
                }
                chart.breadcrumbs.updateProperties(createBreadcrumbsList(chart));
            }
            function onChartAfterDrillUp() {
                const chart = this;
                if (chart.breadcrumbs) {
                    chart.breadcrumbs.updateProperties(createBreadcrumbsList(chart));
                }
            }
            function onChartAfterInit() {
                this.drilldown = new ChartAdditions(this);
            }
            function onChartDrillup() {
                const chart = this;
                if (chart.resetZoomButton) {
                    chart.resetZoomButton = chart.resetZoomButton.destroy();
                }
            }
            function onChartDrillupall() {
                const chart = this;
                if (chart.resetZoomButton) {
                    chart.showResetZoom();
                }
            }
            function onChartRender() {
                (this.xAxis || []).forEach((axis) => {
                    axis.ddPoints = {};
                    axis.series.forEach((series) => {
                        const xData = series.xData || [], points = series.points;
                        for (let i = 0, iEnd = xData.length, p; i < iEnd; i++) {
                            p = series.options.data[i];
                            if (typeof p !== 'number') {
                                p = series.pointClass.prototype.optionsToObject
                                    .call({ series: series }, p);
                                if (p.drilldown) {
                                    if (!axis.ddPoints[xData[i]]) {
                                        axis.ddPoints[xData[i]] = [];
                                    }
                                    const index = i - (series.cropStart || 0);
                                    axis.ddPoints[xData[i]].push(points && index >= 0 && index < points.length ?
                                        points[index] :
                                        true);
                                }
                            }
                        }
                    });
                    objectEach(axis.ticks, (tick) => tick.drillable());
                });
            }
            function onChartUpdate(e) {
                const breadcrumbs = this.breadcrumbs, breadcrumbOptions = e.options.drilldown && e.options.drilldown.breadcrumbs;
                if (breadcrumbs && breadcrumbOptions) {
                    breadcrumbs.update(breadcrumbOptions);
                }
            }
            function svgElementFadeIn(animation) {
                const elem = this;
                elem
                    .attr({
                    opacity: 0.1,
                    visibility: 'inherit'
                })
                    .animate({
                    opacity: pick(elem.newOpacity, 1) 
                }, animation || {
                    duration: 250
                });
            }
            function tickDrillable() {
                const pos = this.pos, label = this.label, axis = this.axis, isDrillable = axis.coll === 'xAxis' && axis.getDDPoints, ddPointsX = isDrillable && axis.getDDPoints(pos), styledMode = axis.chart.styledMode;
                if (isDrillable) {
                    if (label && ddPointsX && ddPointsX.length) {
                        label.drillable = true;
                        if (!label.basicStyles && !styledMode) {
                            label.basicStyles = merge(label.styles);
                        }
                        label.addClass('highcharts-drilldown-axis-label');
                        if (label.removeOnDrillableClick) {
                            removeEvent(label.element, 'click');
                        }
                        label.removeOnDrillableClick = addEvent(label.element, 'click', function (e) {
                            e.preventDefault();
                            axis.drilldownCategory(pos, e);
                        });
                        if (!styledMode && axis.chart.options.drilldown) {
                            label.css(axis.chart.options.drilldown.activeAxisLabelStyle || {});
                        }
                    }
                    else if (label &&
                        label.drillable && label.removeOnDrillableClick) {
                        if (!styledMode) {
                            label.styles = {}; 
                            label.element.removeAttribute('style'); 
                            label.css(label.basicStyles);
                        }
                        label.removeOnDrillableClick(); 
                        label.removeClass('highcharts-drilldown-axis-label');
                    }
                }
            }
        })(Drilldown || (Drilldown = {}));
        ''; 

        return Drilldown;
    });
    _registerModule(_modules, 'masters/modules/drilldown.src.js', [_modules['Core/Globals.js'], _modules['Extensions/Drilldown/Drilldown.js'], _modules['Extensions/Breadcrumbs/Breadcrumbs.js']], function (Highcharts, Drilldown, Breadcrumbs) {

        const G = Highcharts;
        G.Breadcrumbs = G.Breadcrumbs || Breadcrumbs;
        Drilldown.compose(G.Axis, G.Chart, G.defaultOptions, G.Series, G.seriesTypes, G.SVGRenderer, G.Tick);

        return Highcharts;
    });
}));


 })(window);